import { render, staticRenderFns } from "./baseParam.vue?vue&type=template&id=00af1f3e&"
import script from "./baseParam.vue?vue&type=script&lang=js&"
export * from "./baseParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports